import _BlogSection from "./_components/blog-section";
import _BlogPanel from "./_components/blog-panel";

const Blog = _BlogSection;
export default Blog;
export const BlogPanel = _BlogPanel;
